<template>
  <div>
     <v-container>
        <v-row>
          <v-col>
            <div class="home-title mt-4 card-title">The Welland Canal</div>
          </v-col>
        </v-row>
      </v-container>
          <v-container>
        <v-row>
          <v-col lg="4" md="6" xs="12">
            <v-card>
              <v-img max-height="200px" src="../assets/images/Map_2__First_Canal.jpg"></v-img>
              <v-card-title class="card-title">The Welland Canal</v-card-title>
               <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn to="/TheWellandCanal" text class="card-title ">Explore</v-btn>
            </v-card-actions>
            </v-card>
          </v-col>
          <v-col  lg="4" md="6" xs="12">
            <v-card>
              <v-img max-height="200px" src="../assets/images/Photo_5__Construction_985_98_2.jpg"></v-img>
              <v-card-title class="card-title">Construction</v-card-title>  
              <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn to="/Construction" text class="card-title">Explore</v-btn>
            </v-card-actions>
            </v-card>
          </v-col>

          <v-col  lg="4" md="6" xs="12"> 
            <v-card>
              <v-img max-height="200px" src="../assets/images/Photo_2__Grain_Industry_977_454_2.jpg"></v-img>
              <v-card-title class="card-title">Commerce & Industry</v-card-title>
              <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn to="/CommerceIndustry" text class="card-title">Explore</v-btn>
            </v-card-actions>
            </v-card>
           
          </v-col>
   
          <v-col  lg="4" md="6" xs="12">
            <v-card>
              <v-img max-height="200px" src="../assets/images/Photo_1__Ship_Building_976_280_5.jpg"></v-img>
              <v-card-title class="card-title">The Shipbuilders</v-card-title>
              <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn to="/TheShipBuilders" text class="card-title">Explore</v-btn>
            </v-card-actions>
            </v-card>
          </v-col>
          <v-col  lg="4" md="6" xs="12">
            <v-card>
              <v-img max-height="200px" src="../assets/images/Photo_2__West_Street_2010_3_434.jpg"></v-img>
              <v-card-title class="card-title">East St. & West St.</v-card-title>
              <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn to="/EastWest" text class="card-title">Explore</v-btn>
            </v-card-actions>
            </v-card>
          </v-col>
          <v-col  lg="4" md="6" xs="12">
            <v-card class="card-effect">
              <v-img max-height="200px" src="../assets/images/Photo_4___People_and_Pleasures_Boat_excursion_2009_20_81.jpg"></v-img>
              <v-card-title class="card-title">People & Pleasures</v-card-title>
              <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn to="/PeoplePleasures" text class="card-title">Explore</v-btn>
            </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  }
}
</script>
